/**
 * Shared helpers for grouping (slug, version) agent rows into one entry per
 * agent slug, used anywhere a version selector is needed (agent sandbox,
 * workflow node config) as well as the agent library's one-card-per-slug view.
 */

import { AgentConfig } from '../types/agent';

export interface AgentGroup {
  key: string;
  versions: AgentConfig[]; // sorted newest-first
}

export const groupAgentsBySlug = (list: AgentConfig[]): AgentGroup[] => {
  const map = new Map<string, AgentConfig[]>();
  for (const agent of list) {
    const key = agent.slug || agent.id;
    if (!map.has(key)) map.set(key, []);
    map.get(key)!.push(agent);
  }
  return Array.from(map.entries()).map(([key, versions]) => ({
    key,
    versions: versions.slice().sort((a, b) => (parseInt(b.version, 10) || 0) - (parseInt(a.version, 10) || 0)),
  }));
};
